import React from 'react';

const TextArea = ({ 
  value, 
  onChange, 
  placeholder = '', 
  rows = 3,
  disabled = false,
  className = '',
  ...props 
}) => {
  return (
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      className={`
        w-full px-3 py-2 
        bg-background border border-border rounded-lg
        text-sm text-foreground placeholder-muted-foreground
        focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-smooth
        resize-vertical
        ${className}
      `}
      {...props}
    />
  );
};

export default TextArea;

